// Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Facebook } from 'lucide-react';
import whiteLogo from '../assets/white_logo.png';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="py-24 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Main Footer Content - 4 Columns */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            
            {/* Brand Column */}
            <div className="lg:col-span-1">
              <img src={whiteLogo} alt="Validate Systems" className="h-10 mb-4" />
              <p className="text-gray-400 mb-6 leading-relaxed font-light">
                Human-verified trust and mobility services. Verification and immigration support for African markets.
              </p>
              <div className="flex space-x-4">
                <a 
                  href="https://facebook.com/validatesystems" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  <Facebook size={20} />
                </a>
              </div>
            </div>

            {/* Contact Column */}
            <div className="lg:col-span-1">
              <h4 className="text-lg font-semibold text-white mb-4">Contact</h4>
              
              <div className="text-sm text-gray-400 space-y-3 font-light">
                <div className="flex items-start">
                  <MapPin size={14} className="mr-2 mt-0.5 flex-shrink-0" />
                  <span>36, Ilupeju Street, Camp FUNAAB, Ogun State, Nigeria</span>
                </div>
                <div className="flex items-center">
                  <Phone size={14} className="mr-2 flex-shrink-0" />
                  <span>+234 806 553 1248</span>
                </div>
                <div className="flex items-center">
                  <Phone size={14} className="mr-2 flex-shrink-0" />
                  <span>+234 707 255 9063</span>
                </div>
                <div className="flex items-center">
                  <Mail size={14} className="mr-2 flex-shrink-0" />
                  <span>info@validatesystems.com</span>
                </div>
                <div className="flex items-start">
                  <Clock size={14} className="mr-2 mt-0.5 flex-shrink-0" />
                  <span>Mon–Fri, 09:00–17:00 WAT</span>
                </div>
              </div>
            </div>

            {/* Services Column */}
            <div className="lg:col-span-1">
              <h4 className="text-lg font-semibold text-white mb-4">Services</h4>
              <ul className="space-y-2 text-sm text-gray-400 font-light">
                <li>
                  <Link to="/verification" className="hover:text-white transition-colors">
                    Verification Services
                  </Link>
                </li>
                <li>
                  <Link to="/travel" className="hover:text-white transition-colors">
                    Travel & Immigration
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="hover:text-white transition-colors">
                    Consultation
                  </Link>
                </li>
              </ul>
            </div>

            {/* Legal Column */}
            <div className="lg:col-span-1">
              <h4 className="text-lg font-semibold text-white mb-4">Legal</h4>
              <ul className="space-y-2 text-sm text-gray-400 font-light">
                <li>
                  <Link to="/privacy-policy" className="hover:text-white transition-colors">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/terms-of-service" className="hover:text-white transition-colors">
                    Terms of Service
                  </Link>
                </li>
                <li>
                  <Link to="/refund-policy" className="hover:text-white transition-colors">
                    Refund Policy
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
